// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3_5eZ","buttons":"Footer_buttons__3PSU4"};